import React, { useMemo } from 'react';

// @ts-ignore: TS2459 — we know it's there at runtime
import { AttendanceChart } from '@PikaDoApp/pikado-web-dsm';


interface AttendanceChartContainerProps {
  selectedMonth: string;
  onMonthChange: (month: string) => void;
  monthOptions: Array<{label: string; value: string}>;
  studentsDailyRecord:Array<any>;
  totalAnswersCount:number;
  totalStudentsEngagedThisMonth:number
}

export const AttendanceChartContainer: React.FC<AttendanceChartContainerProps> = ({
  selectedMonth,
  onMonthChange,
  monthOptions,
  studentsDailyRecord,
  totalAnswersCount,
  totalStudentsEngagedThisMonth
}) => {

  // Ensure numeric values are valid to prevent NaN in SVG paths
  const validatedTotalAnswersCount = useMemo(() => {
    return Number.isFinite(totalAnswersCount) ? totalAnswersCount : 0;
  }, [totalAnswersCount]);

  const validatedTotalStudentsEngaged = useMemo(() => {
    return Number.isFinite(totalStudentsEngagedThisMonth) ? totalStudentsEngagedThisMonth : 0;
  }, [totalStudentsEngagedThisMonth]);

  return (
    <AttendanceChart
    totalAnswersCount={validatedTotalAnswersCount}
    totalStudentsEngagedThisMonth={validatedTotalStudentsEngaged}
    studentsDailyRecord={studentsDailyRecord}
      monthOptions={monthOptions}
      selectedMonth={selectedMonth}
      onMonthChange={onMonthChange}
    />
  );
};
